/**
 * ngbms-rostering
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export interface Contact { 
    /**
     * Contact infomation
     */
    value?: string;
    /**
     * Contact type
     */
    type?: Contact.TypeEnum;
}
export namespace Contact {
    export type TypeEnum = 'EMAIL' | 'MOBILE' | 'HOME' | 'OFFICE' | 'WHATSAPP' | 'TELEGRAM' | 'WECHAT' | 'LINE';
    export const TypeEnum = {
        Email: 'EMAIL' as TypeEnum,
        Mobile: 'MOBILE' as TypeEnum,
        Home: 'HOME' as TypeEnum,
        Office: 'OFFICE' as TypeEnum,
        Whatsapp: 'WHATSAPP' as TypeEnum,
        Telegram: 'TELEGRAM' as TypeEnum,
        Wechat: 'WECHAT' as TypeEnum,
        Line: 'LINE' as TypeEnum
    };
}


